import { loadable } from "components/SpruceLoader";

export const AdminSettings = loadable(() => import("./adminSettings/index"));
